import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TooltipProvider } from '@zafroi/ui-kit';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/services/auth-context';
import { TenantProvider } from '@/services/tenant-context';
import { AppRoutes } from '@/routes/AppRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// Router basename derived from Vite's base (import.meta.env.BASE_URL):
//  - subdomain build (base '/')      → BASE_URL '/'      → basename '/'
//  - workspace build (base '/kosh/') → BASE_URL '/kosh/' → basename '/kosh'
// Lets the SAME app serve at kosh.zafroi.com AND app.zafroi.com/kosh/ (ADR-022 Option B).
const ROUTER_BASENAME = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <AuthProvider>
          <TenantProvider>
            <TooltipProvider delayDuration={200}>
              <AppRoutes />
            </TooltipProvider>
          </TenantProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors closeButton position="top-right" />
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
    </QueryClientProvider>
  );
}
